import { DomainState } from './types';

const state: DomainState = {
};

export default state;
